import * as React from 'react'
import { useCallback } from 'react'

import { ENTITY_TYPES, SOLD_SERVICE_STATUS } from '@sales-center/common'
import { ClosedLostDialogContent } from './ClosedLostDialogContent'
import {
  closeDialogActionCreator as closeDialog,
  useCWQDialogContext,
} from '../SoldServices'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import { useTheme } from '@mui/material/styles'

type Props = {
  entityId: number
  salesFunnelId: number
  assigneeId: string | null
  entityType: ENTITY_TYPES
  soldServiceStatus?: SOLD_SERVICE_STATUS
}

export function ClosedLostReasonsDialog(props: Props) {
  const { entityId, entityType, salesFunnelId, assigneeId, soldServiceStatus } =
    props

  const title =
    entityType === ENTITY_TYPES.Lead ? 'Disqualified' : 'Mark as Closed/Lost'

  const [{ activeDialog }, dispatch] = useCWQDialogContext()

  const open = activeDialog === 'closeLose'

  const onClose = useCallback(() => dispatch(closeDialog()), [dispatch])
  const theme = useTheme()
  return (
    <Dialog fullWidth open={open} maxWidth="xs" onClose={onClose}>
      <DialogTitle
        fontSize="20px"
        color={theme.palette.text.primary}
        sx={{
          p: 3,
          pb: '16px',
        }}
      >
        {title}
      </DialogTitle>

      <ClosedLostDialogContent
        onClose={onClose}
        entityId={entityId}
        entityType={entityType}
        salesFunnelId={salesFunnelId}
        assigneeId={assigneeId}
        soldServiceStatus={soldServiceStatus}
      />
    </Dialog>
  )
}
